import { useAllOffers } from '../api/api.calls';
import { useMemo } from 'react';

const useOffers = () => {
  const { data: apiResponse } = useAllOffers() || {};
  const { data = [] } = apiResponse || {};

  const getSortedOffers = (data) => {
    // Step 1: Group offers by brand_id
    const brandMap = new Map();
    data.forEach((offer) => {
      if (!brandMap.has(offer.brand_id)) {
        brandMap.set(offer.brand_id, []);
      }
      brandMap.get(offer.brand_id).push(offer);
    });
    // Convert Map to an array of offer lists
    let brandOffers = Array.from(brandMap.values());
    // Step 2: Pick offers in a round-robin fashion
    let sortedOffers = [];
    let index = 0; // Track the index of the offer to pick
    while (sortedOffers.length < 6) {
      let allPicked = true;
      for (let offers of brandOffers) {
        if (offers.length > index) {
          sortedOffers.push(offers[index]);
          allPicked = false;
          if (sortedOffers.length === 6) break; // Stop if we reach 6
        }
      }
      if (allPicked) break; // Stop if no more offers can be picked
      index++; // Move to the next index for the next round
    }
    return sortedOffers;
  };

  const {
    discountOffers,
    exclusiveOffers,
    recommendedOffers,
    guranteedSavings,
    offlineOffers,
    topOffers,
  } = useMemo(() => {
    const offers = {
      discountOffers: [],
      exclusiveOffers: [],
      recommendedOffers: [],
      guranteedSavings: [],
      offlineOffers: [],
      topOffers: [],
    };
    offers.topOffers = getSortedOffers(data).length > 0 && [
      ...getSortedOffers(data),
    ];

    for (const entry of data) {
      if (entry.offer_type === 'INSTANT') {
        offers.discountOffers.push(entry);
      }
      if (entry.offer_filter_type === 'exclusive') {
        offers.exclusiveOffers.push(entry);
      }
      if (entry.offer_filter_type === 'recommended') {
        offers.recommendedOffers.push(entry);
      }
      if (entry.offer_filter_type === 'guaranteed') {
        offers.recommendedOffers.push(entry);
      }
      if (entry.type === 'offline') {
        offers.offlineOffers.push(entry);
      }
    }

    return offers;
  }, [data]);

  return {
    discountOffers,
    exclusiveOffers,
    recommendedOffers,
    guranteedSavings,
    offlineOffers,
    topOffers,
  };
};

export default useOffers;
